<template>
  <div
    class="modal fade"
    :class="classNames"
    :id="id"
    :style="styles"
    tabindex="-1"
    role="dialog"
    :aria-labelledby="`${id}Label`"
    aria-hidden="true"
  >
    <div class="modal-dialog" :class="dialogClasses" role="document">
      <div class="modal-content">
        <div class="modal-header" v-if="showHeader">
          <slot name="modal-title"></slot>

          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="hideModal"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <slot></slot>
        </div>
        <div class="modal-footer" v-if="showFooter">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getters } from "../../store/Bootstrap";

export default {
  props: {
    id: { type: String, required: true },
    dialogCentered: { type: Boolean, default: false },
    dialogScrollable: { type: Boolean, default: false },
    showHeader: { type: Boolean, default: false },
    showFooter: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    large: { type: Boolean, default: false },
    full: { type: Boolean, default: false },
    confirmClose: { type: String, default: null }
  },
  data() {
    return {
      showFlag: false,
      showClass: false
    };
  },
  computed: {
    showing() {
      return getters.checkModalShowing(this.id);
    },
    classNames() {
      return {
        show: this.showClass
      };
    },
    styles() {
      return {
        display: this.showFlag ? "block" : "none"
      };
    },
    dialogClasses() {
      return {
        "modal-dialog-centered": this.dialogCentered,
        "modal-dialog-scrollable": this.dialogScrollable,
        "modal-sm": this.small,
        "modal-lg": this.large,
        "modal-full": this.full
      };
    }
  },
  watch: {
    showing: {
      immediate: true,
      handler: function(newVal) {
        if (newVal) {
          this.showFlag = true;
          setTimeout(() => {
            this.showClass = true;
          }, 10);
        } else {
          this.showClass = false;
          setTimeout(() => {
            this.showFlag = false;
          }, 100);
        }
      }
    }
  },
  methods: {
    hideModal() {
      if (this.$props.confirmClose) {
        if (!window.confirm(this.$props.confirmClose)) {
          return;
        }
      }

      this.$bootstrap.hideModal(this.id);
      this.$emit("close", this.id);
    }
  }
};
</script>
